import type { HttpMock } from '#e2e-utils/mockScenarios';
import { ControllerStatus } from '#models/ControllerStatus.enum';
import type { ControllerDetails } from '#services/cve/ControllerDetails';

export const esgRejectedMocks: HttpMock[] = [
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/EnergyPolicy$',
    },
    response: {
      status: 200,
      body: {
        controlCode: 'EnergyPolicy',
        statusCode: ControllerStatus.CHECK_REJECTED,
        check: {
          requestorId: 'CVE',
          requestDateTime: '2024-05-21T13:29:56.409Z',
          responseDateTime: '2024-05-21T13:29:56.409Z',
          expirationDateTime: '2025-05-21T13:29:56.409Z',
          controlData: {
            escalationContact: 'test@allianz-trade.com',
            companyId: '113',
            tradeSectors: [
              { code: '4265', isMain: false },
              { code: '1234', isMain: true },
              { code: '9856', isMain: false },
            ],
          },
        },
      } satisfies ControllerDetails,
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/SensitiveBusiness$',
    },
    response: {
      status: 200,
      body: {
        controlCode: 'SensitiveBusiness',
        statusCode: ControllerStatus.CHECK_REJECTED,
        check: {
          requestorId: 'CVE',
          requestDateTime: '2024-05-21T13:29:56.409Z',
          responseDateTime: '2024-05-21T13:29:56.409Z',
          expirationDateTime: '2025-05-21T13:29:56.409Z',
          controlData: {
            escalationContact: 'test@allianz-trade.com',
            companyId: '113',
            tradeSectors: [
              { code: '4265', isMain: false },
              { code: '1234', isMain: true },
              { code: '9856', isMain: false },
            ],
          },
        },
      } satisfies ControllerDetails,
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/SensitiveCountry$',
    },
    response: {
      status: 200,
      body: {
        controlCode: 'SensitiveCountry',
        statusCode: ControllerStatus.CHECK_REJECTED,
        check: {
          requestorId: 'CVE',
          requestDateTime: '2024-05-21T13:29:56.409Z',
          responseDateTime: '2024-05-21T13:29:56.409Z',
          expirationDateTime: '2025-05-21T13:29:56.409Z',
          controlData: {
            escalationContact: 'test@allianz-trade.com',
            companyId: '113',
            countryCode: 'KP',
          },
        },
      } satisfies ControllerDetails,
    },
  },
];
